<main class="page-shell leaderboard-page">
  <section *ngIf="loading" class="card state">Loading leaderboard...</section>
  <section *ngIf="error" class="card state status-error">{{ error }}</section>

  <ng-container *ngIf="!loading && !error">
    <section class="card hero">
      <div>
        <h1>Leaderboard</h1>
        <p>Rankings across global XP, weekly consistency, and topic mastery.</p>
      </div>
      <div class="scope-switch">
        <button class="scope-btn" [class.active]="scope === 'global'" (click)="setScope('global')">Global</button>
        <button class="scope-btn" [class.active]="scope === 'weekly'" (click)="setScope('weekly')">Weekly</button>
        <button class="scope-btn" [class.active]="scope === 'topic'" (click)="setScope('topic')">By Topic</button>
      </div>
    </section>

    <section class="card topic-row" *ngIf="scope === 'topic'">
      <label>
        Topic ranking
        <select [ngModel]="selectedTopic" (ngModelChange)="onTopicChange($event)">
          <option *ngFor="let item of categories; trackBy: trackByCategory" [value]="item.topic">{{ item.topic }}</option>
        </select>
      </label>
    </section>

    <section class="card table-card">
      <table>
        <thead>
          <tr>
            <th>Rank</th>
            <th>User</th>
            <th>XP</th>
            <th>Level</th>
            <th>Streak</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; trackBy: trackByRow">
            <td class="rank-cell">#{{ row.rank }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.xp }}</td>
            <td>{{ row.level }}</td>
            <td>{{ row.streak }}</td>
          </tr>
        </tbody>
      </table>
      <p class="empty" *ngIf="rows.length === 0">No ranking data yet for this scope.</p>
    </section>
  </ng-container>
</main>
